var _path, _path2, _path3, _g, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEnterpriseCorporationInsurance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.56821 41.1811C-1.16699 33.83 -1.62517 21.486 2.8758 13.4611C12.1203 -3.18174 41.599 0.382649 43.7147 6.09645C44.9882 9.56651 36.7005 15.159 38.6275 18.4539C40.0492 20.8931 45.0758 18.7032 47.1308 21.203C49.9069 24.572 45.7428 34.679 38.7623 40.2917C31.0001 46.5176 16.0485 50.1561 6.56821 41.1811Z",
    fill: "#FDDC9D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0025 11.8376H28.5947V10.2878C28.6003 10.2457 28.5974 10.2028 28.5861 10.1618C28.5748 10.1208 28.5554 10.0825 28.529 10.0492C28.5026 10.0159 28.4697 9.98821 28.4324 9.96786C28.3951 9.9475 28.354 9.93487 28.3117 9.93072H23.8916C23.8916 8.15189 23.8916 6.56173 23.8916 6.05638C23.8916 6.01349 23.8745 5.97236 23.8442 5.94204C23.8139 5.91171 23.7728 5.89467 23.7299 5.89467H23.494C23.4722 5.89376 23.4505 5.89727 23.4301 5.90499C23.4097 5.91271 23.3911 5.92448 23.3753 5.93959C23.3596 5.95469 23.3471 5.97283 23.3385 5.9929C23.33 6.01297 23.3256 6.03457 23.3256 6.05638V9.93072H18.9257C18.8834 9.93487 18.8423 9.9475 18.805 9.96786C18.7677 9.98821 18.7348 10.0159 18.7084 10.0492C18.682 10.0825 18.6626 10.1208 18.6513 10.1618C18.64 10.2028 18.6371 10.2457 18.6427 10.2878V11.8376H11.8104C11.715 11.8376 11.6235 11.875 11.5555 11.9417C11.4874 12.0085 11.4483 12.0994 11.4465 12.1947V13.859H35.7909V12.5855C35.7821 12.3829 35.695 12.1917 35.5479 12.0521C35.4008 11.9126 35.2053 11.8356 35.0025 11.8376Z",
    fill: "#274168"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1209_137417",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 1,
    width: 48,
    height: 46
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.56821 41.1811C-1.16699 33.83 -1.62517 21.486 2.8758 13.4611C12.1203 -3.18174 41.599 0.382649 43.7147 6.09645C44.9882 9.56651 36.7005 15.159 38.6275 18.4539C40.0492 20.8931 45.0758 18.7032 47.1308 21.203C49.9069 24.572 45.7428 34.679 38.7623 40.2917C31.0001 46.5176 16.0485 50.1561 6.56821 41.1811Z",
    fill: "#FDDC9D"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1209_137417)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.4465 48.4383L35.7909 48.4316V13.832H11.4465V48.4383Z",
    fill: "white"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3848 18.5283H25.852V20.8731C25.852 21.1561 25.6903 21.392 25.4949 21.392H21.7419C21.5397 21.392 21.3848 21.1561 21.3848 20.8731V18.5283Z",
    fill: "#C4D9F1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7898 18.5283H33.2571V20.8731C33.2571 21.1561 33.0954 21.392 32.9 21.392H29.1536C28.9515 21.392 28.7965 21.1561 28.7965 20.8731L28.7898 18.5283Z",
    fill: "#C4D9F1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9867 18.5283H18.454V20.8731C18.454 21.1561 18.2922 21.392 18.0968 21.392H14.3303C14.1349 21.392 13.9732 21.1561 13.9799 20.8731L13.9867 18.5283Z",
    fill: "#C4D9F1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3848 25.8125H25.852V28.1506C25.852 28.4403 25.6903 28.6694 25.4949 28.6694H21.7419C21.5397 28.6694 21.3848 28.4403 21.3848 28.1506V25.8125Z",
    fill: "#C4D9F1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9934 25.8193H18.4606V28.1574C18.4606 28.4471 18.2989 28.6762 18.1035 28.6762H14.3303C14.1349 28.6762 13.9731 28.4471 13.9731 28.1574L13.9934 25.8193Z",
    fill: "#C4D9F1"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7898 25.8193H33.2571V28.1574C33.2571 28.4471 33.0954 28.6762 32.9 28.6762H29.1536C28.9515 28.6762 28.7965 28.4471 28.7965 28.1574L28.7898 25.8193Z",
    fill: "#C4D9F1"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3848 32.9746H25.8453V35.3127C25.8453 35.6024 25.6836 35.8315 25.4882 35.8315H21.7419C21.5465 35.8315 21.3848 35.5957 21.3848 35.306V32.9746Z",
    fill: "#C4D9F1"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9866 32.9746H18.4539V35.3127C18.4539 35.6024 18.2922 35.8315 18.0901 35.8315H14.3303C14.1349 35.8315 13.9731 35.6024 13.9731 35.3127L13.9866 32.9746Z",
    fill: "#C4D9F1"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7898 32.9678H33.2503V35.3126C33.2503 35.5956 33.0886 35.8314 32.8932 35.8314H29.1536C28.9582 35.8314 28.7965 35.5956 28.7965 35.3126L28.7898 32.9678Z",
    fill: "#C4D9F1"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3848 40.2109H25.8453V42.549C25.8453 42.8387 25.6836 43.0678 25.4882 43.0678H21.7419C21.5465 43.0678 21.3848 42.832 21.3848 42.5423V40.2109Z",
    fill: "#C4D9F1"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9866 40.2109H18.4539V42.549C18.4539 42.8387 18.2922 43.0678 18.0901 43.0678H14.3303C14.1349 43.0678 13.9731 42.8387 13.9731 42.549L13.9866 40.2109Z",
    fill: "#C4D9F1"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7898 40.2051H33.2503V42.5499C33.2503 42.8329 33.0886 43.0687 32.8932 43.0687H29.1536C28.9582 43.0687 28.7965 42.8329 28.7965 42.5499L28.7898 40.2051Z",
    fill: "#C4D9F1"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7419 16.1904H25.4882C25.6903 16.1904 25.8453 16.4263 25.8453 16.7093V18.5285H21.3848V16.7093C21.3915 16.4263 21.5532 16.1904 21.7419 16.1904Z",
    fill: "#7698CB"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3302 16.1904H18.0765C18.2787 16.1904 18.4336 16.4263 18.4336 16.7093V18.5285H13.9866V16.7093C13.9933 16.4263 14.155 16.1904 14.3302 16.1904Z",
    fill: "#7698CB"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1536 16.1904H32.9C33.1021 16.1904 33.2571 16.4263 33.2571 16.7093V18.5285H28.7898V16.7093C28.7965 16.4263 28.9515 16.1904 29.1536 16.1904Z",
    fill: "#7698CB"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7419 23.4746H25.4882C25.6903 23.4746 25.8453 23.7104 25.8453 23.9934V25.8194H21.3848V23.9665C21.3915 23.7104 21.5532 23.4746 21.7419 23.4746Z",
    fill: "#7698CB"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3302 23.4746H18.0765C18.2787 23.4746 18.4336 23.7104 18.4336 23.9934V25.8194H13.9866V23.9665C13.9933 23.7104 14.155 23.4746 14.3302 23.4746Z",
    fill: "#7698CB"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1536 23.4746H32.9C33.1021 23.4746 33.2571 23.7104 33.2571 23.9934V25.8194H28.7898V23.9665C28.7965 23.7104 28.9515 23.4746 29.1536 23.4746Z",
    fill: "#7698CB"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7419 30.6299H25.4882C25.6903 30.6299 25.8453 30.8657 25.8453 31.1554V32.9747H21.3848V31.1554C21.3915 30.8657 21.5532 30.6299 21.7419 30.6299Z",
    fill: "#7698CB"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3302 30.6299H18.0765C18.2787 30.6299 18.4336 30.8657 18.4336 31.1554V32.9747H13.9866V31.1554C13.9933 30.8657 14.155 30.6299 14.3302 30.6299Z",
    fill: "#7698CB"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1536 30.6299H32.9C33.1021 30.6299 33.2571 30.8657 33.2571 31.1554V32.9747H28.7898V31.1554C28.7965 30.8657 28.9515 30.6299 29.1536 30.6299Z",
    fill: "#7698CB"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7419 37.8662H25.4882C25.6903 37.8662 25.8453 38.0953 25.8453 38.385V40.2043H21.3848V38.385C21.3915 38.1155 21.5532 37.8662 21.7419 37.8662Z",
    fill: "#7698CB"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3302 37.8662H18.0765C18.2787 37.8662 18.4336 38.0953 18.4336 38.385V40.2043H13.9866V38.385C13.9933 38.1155 14.155 37.8662 14.3302 37.8662Z",
    fill: "#7698CB"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1536 37.8662H32.9C33.1021 37.8662 33.2571 38.0953 33.2571 38.385V40.2043H28.7898V38.385C28.7965 38.1155 28.9515 37.8662 29.1536 37.8662Z",
    fill: "#7698CB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnterpriseCorporationInsurance);
export default __webpack_public_path__ + "static/media/enterprise-corporation-insurance.f7e3e16b9632378bea011b48c0cc41b7.svg";
export { ForwardRef as ReactComponent };